import firebase from 'firebase';

const firebaseConfig = {
  apiKey: 'AIzaSyBsO67jWWlqaa650ESqYo7ueHdy6O_68Ho',
  authDomain: 'course-search-502c6.firebaseapp.com',
  projectId: 'course-search-502c6',
};

firebase.initializeApp(firebaseConfig);

firebase.firestore();

export default firebase;
